import axios from "axios";

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL + '/api',
});

export const axiosInstancePublic = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL + '/api',
});

axiosInstancePublic.interceptors.request.use((config) => {
    config.headers["Content-Type"] = "application/json";
    return config;
});

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/json";
        }
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
});

export default axiosInstance;
